// extracted by mini-css-extract-plugin
module.exports = {"container":"PolygonMenuPopup_container__2cm9p","option":"PolygonMenuPopup_option__20HIL"};